export function getSubdomain() {
	const hostnameParts = location.hostname.split(".");
	if (hostnameParts.length >= 3) {
		return hostnameParts[0];
	}
}

export function getProduct() {
	const hostnameParts = location.hostname.split(".");
	if (hostnameParts.length >= 3) {
		return hostnameParts[1];
	}
}

export function getDomain() {
	const hostnameParts = location.hostname.split(".");
	if (hostnameParts.length >= 3) {
		return "." + hostnameParts.slice(2, hostnameParts.length).join(".");
	}
}
